import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Close from "../../assets/svgs/close.svg";
import webSocketService from "../../services/WebSocketService";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import {
  currencyTypes,
  getModalCustomStyles,
  toastOptions,
} from "../../utils/constants/constants";
import Button from "../Button/Button";
import CustomSelect from "../CustomSelect/CustomSelect";
import Input from "../Input/Input";
import "./ChargeUserModal.scss";
import SecondaryButton from "../SecondaryButton/SecondaryButton";

const ChargeUserModal = ({
  showChargeModal = true,
  setShowChargeModal,
  userId = "",
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [selectedCoin, setSelectedCoin] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [data, setData] = useState(false);

  const onSubmit = async (formData) => {
    setData(formData);
    setShowConfirm(true);
  };
  const onCharge = async () => {
    setLoading(true);
    const creditData = { ...data, userId };
    const result = await webSocketService.sendMessage(
      "charge",
      "c",
      creditData,
    );

    if (result === "") {
      toast.success("Charge success!", toastOptions);
      setShowChargeModal(false);
    } else {
      toast.error(capitalizeFirstLetter(result), toastOptions);
    }
    setLoading(false);
  };

  return showChargeModal ? (
    <Modal
      isOpen={showChargeModal}
      style={getModalCustomStyles(showConfirm ? 150 : 350)}
      ariaHideApp={false}
    >
      <form
        className={`charge-modal__wrapper ${
          showConfirm ? "charge-modal__hidden" : ""
        }`}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="charge-modal__header">
          <span className="charge-modal__header-label">Charge User</span>
          <img
            className="charge-modal__close"
            src={Close}
            alt="close"
            onClick={() => setShowChargeModal(false)}
          />
        </div>

        <CustomSelect
          label="Currency"
          name="currency"
          control={control}
          options={currencyTypes}
          placeholder="Select currency..."
          errors={errors}
          rules={{ required: "This field is required" }}
          onSelect={(coin) => {
            setSelectedCoin(coin);
            setValue("amount", "");
          }}
        />
        <Input
          label="Amount"
          placeholder="Enter amount"
          name="amount"
          register={register}
          errors={errors}
          inputStyles="charge-modal__input"
          rules={{
            required: "This field is required",
            pattern: {
              value:
                selectedCoin === "USD"
                  ? /^[0-9]+(\.[0-9]{1,2})?$/
                  : /^[0-9]+(\.[0-9]{1,8})?$/,
              message: `Integer or decimal numbers in the format ${
                selectedCoin === "USD" ? "XX.XX" : "XX.XXXXXXXX"
              }`,
            },
          }}
        />

        <Button
          label="Charge"
          type="submit"
          wrapperStyles="charge-modal__button"
          loading={loading}
        />
      </form>
      <div
        className={`confirm-modal__wrapper ${
          !showConfirm ? "charge-modal__hidden" : ""
        }`}
      >
        <span className="confirm-modal__title">Are you sure?</span>
        <span className="confirm-modal__subtitle">
          Do you want to Charge user?
        </span>
        <div className="confirm-modal__buttons">
          <SecondaryButton
            title="No, Cancel"
            wrapperClass="confirm-modal__button"
            onClick={() => setShowConfirm(false)}
            labelClass="confirm-modal__label-no"
          />
          <Button
            wrapperStyles="confirm-modal__button confirm-modal__button-yes"
            labelStyles="confirm-modal__label-yes"
            label="Yes, Charge"
            onPress={onCharge}
          />
        </div>
      </div>
    </Modal>
  ) : null;
};

export default ChargeUserModal;
